import { render, staticRenderFns } from "./ModalOpenTicket.vue?vue&type=template&id=851002ee&lang=html&"
import script from "./ModalOpenTicket.vue?vue&type=script&lang=js&"
export * from "./ModalOpenTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports